import { render, staticRenderFns } from "./materialUpload.vue?vue&type=template&id=01041556&scoped=true&"
import script from "./materialUpload.vue?vue&type=script&lang=js&"
export * from "./materialUpload.vue?vue&type=script&lang=js&"
import style0 from "./materialUpload.vue?vue&type=style&index=0&id=01041556&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01041556",
  null
  
)

export default component.exports